<section class="content">
  <div class="container">
    <h3 class="text strat pt-3">Tyre Brand</h3>
    <form (ngSubmit)="saveTyreBrand()" [formGroup]="addTyreBrandForm">
      <div class="row pt-3">
        <div class="col-md-6">
          <label for="name">Name</label>
          <input
            formControlName="name"
            id="name"
            type="text"
            class="form-control"
            required
            placeholder="Enter name*"
            >
            @if (
              addTyreBrandForm.get('name')?.invalid &&
              addTyreBrandForm.get('name')?.touched
              ) {
              <div
                >
                <small class="text-danger">Name is required</small>
              </div>
            }
          </div>
          <div class="col-md-6">
            <div class="col-12 text-end p-3">
              <button
                type="submit"
                class="btn app-btn-primary"
                [disabled]="addTyreBrandForm.invalid"
              >Submit</button>
              <div>{{responseMsg}}</div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </section>
